import { PhoneIcon } from '@heroicons/react/24/solid';
import { Input } from '@heroui/react';
import type { FC } from 'react';
import { type Control, Controller } from 'react-hook-form';
import { isPossiblePhoneNumber } from 'react-phone-number-input';

interface PhoneInputProps {
  name: string;
  label: string;
  control: Control<any>;
  required?: boolean;
}

const validatePhoneNumber = (value: string): boolean | string => {
  if (!value) {
    return true;
  }

  if (isPossiblePhoneNumber(value)) {
    return true;
  }

  if (isPossiblePhoneNumber(value, 'US')) {
    return true;
  }

  return 'Invalid phone number';
};

export const PhoneInput: FC<PhoneInputProps> = ({ name, label, control, required }) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: required ? 'This field is required' : undefined,
        validate: {
          format: validatePhoneNumber,
        },
      }}
      render={({ field, fieldState }) => (
        <Input
          {...field}
          label={label}
          variant='bordered'
          type='tel'
          isRequired={required}
          isInvalid={fieldState.invalid}
          errorMessage={fieldState.error?.message}
          startContent={<PhoneIcon className='size-4 text-default-400' />}
        />
      )}
    />
  );
};
